<template>
  <div class="medical-stats-container">
    <!-- 页面标题和筛选区域 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">
          <i class="el-icon-s-data"></i>
          医疗数据统计分析
        </h1>
        <p class="page-subtitle">全面掌握医院运营数据，助力科学决策</p>
      </div>
      <div class="date-filter">
        <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="handleDateChange"
        >
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="fetchData">查询</el-button>
      </div>
    </div>

    <!-- 统计概览卡片 -->
    <div class="overview-cards">
      <el-card class="overview-card" shadow="hover">
        <div class="card-content">
          <div class="card-icon-wrapper" style="background: #e6f7ff;">
            <i class="el-icon-tlzt" style="color: #1890ff;"></i>
          </div>
          <div class="card-info">
            <div class="card-value">{{ totalDrugs }}</div>
            <div class="card-label">药品总数</div>
          </div>
        </div>
      </el-card>

      <el-card class="overview-card" shadow="hover">
        <div class="card-content">
          <div class="card-icon-wrapper" style="background: #f6ffed;">
            <i class="el-icon-user-solid card-icon" style="color: #52c41a;"></i>
          </div>
          <div class="card-info">
            <div class="card-value">{{ totalDoctors }}</div>
            <div class="card-label">医生总数</div>
          </div>
        </div>
      </el-card>

      <el-card class="overview-card" shadow="hover">
        <div class="card-content">
          <div class="card-icon-wrapper" style="background: #fff7e6;">
            <i class="el-icon-shopping-cart-2 card-icon" style="color: #fa8c16;"></i>
          </div>
          <div class="card-info">
            <div class="card-value">¥{{ totalSales }}</div>
            <div class="card-label">总销售额</div>
          </div>
        </div>
      </el-card>

      <el-card class="overview-card" shadow="hover">
        <div class="card-content">
          <div class="card-icon-wrapper" style="background: #f9f0ff;">
            <i class="el-icon-document card-icon" style="color: #722ed1;"></i>
          </div>
          <div class="card-info">
            <div class="card-value">{{ totalPrescriptions }}</div>
            <div class="card-label">处方总数</div>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 统计模块Tab切换 -->
    <el-card class="main-content-card" shadow="never">
      <template #header>
        <div class="tab-header">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="药品统计" name="drug">
              <template #label>
                <span class="tab-label">
                  <i class="el-icon-link"></i>
                  药品统计
                </span>
              </template>
            </el-tab-pane>
            <el-tab-pane label="医生统计" name="doctor">
              <template #label>
                <span class="tab-label">
                  <i class="el-icon-user-solid"></i>
                  医生统计
                </span>
              </template>
            </el-tab-pane>
            <el-tab-pane label="财务收入明细" name="finance">
              <template #label>
                <span class="tab-label">
                  <i class="el-icon-money"></i>
                  财务收入明细
                </span>
              </template>
            </el-tab-pane>
            <el-tab-pane label="销售分析" name="sales">
              <template #label>
                <span class="tab-label">
                  <i class="el-icon-s-data"></i>
                  销售分析
                </span>
              </template>
            </el-tab-pane>
            <el-tab-pane label="患者分析" name="patient">
              <template #label>
                <span class="tab-label">
                  <i class="el-icon-user"></i>
                  患者分析
                </span>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>

      <!-- 药品统计 -->
      <div v-show="activeTab === 'drug'" class="tab-content">
        <div class="chart-controls">
          <el-radio-group v-model="drugChartType" size="small" @change="renderDrugCharts">
            <el-radio-button label="sale">销售额分析</el-radio-button>
            <el-radio-button label="count">销售数量</el-radio-button>
            <el-radio-button label="profit">利润分析</el-radio-button>
            <el-radio-button label="type">类型分布</el-radio-button>
          </el-radio-group>
        </div>

        <div class="chart-container">
          <div id="drugMainChart" class="main-chart" style="height: 500px;"></div>
        </div>

        <el-card class="data-table-card" shadow="never">
          <template #header>
            <div class="table-header">
              <div class="table-title">
                <i class="el-icon-first-aid"></i>
                <span>药品销售明细</span>
              </div>
<!--              <el-button type="primary" size="small" icon="el-icon-download">导出数据</el-button>-->
            </div>
          </template>
          <el-table
              :data="drugData"
              stripe
              border
              v-loading="drugLoading"
              style="width: 100%"
              empty-text="暂无药品数据"
          >
            <el-table-column prop="drugName" label="药品名称" min-width="150" fixed align="center">
              <template #default="scope">
                <div class="drug-name-cell">
                  <i class="el-icon-medal" :style="{color: scope.row.type === 1 ? '#1890ff' : '#52c41a'}"></i>
                  {{ scope.row.drugName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" width="100" align="center">
              <template #default="scope">
                <el-tag :type="scope.row.type === 1 ? 'primary' : 'success'" effect="dark">
                  {{ scope.row.type === 1 ? '西药' : '中药' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="cnt" label="销售数量" width="120" sortable align="center" >
              <template #default="scope">
                <span class="number-cell">{{ scope.row.cnt.toLocaleString() }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="purcAmt" label="成本金额" width="140" sortable align="center">
              <template #default="scope">
                <span class="money-cell cost">¥{{ scope.row.purcAmt.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="saleAmt" label="零售金额" width="140" sortable align="center">
              <template #default="scope">
                <span class="money-cell sale">¥{{ scope.row.saleAmt.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="profit" label="利润" width="140" sortable align="center">
              <template #default="scope">
                <span :class="['money-cell', scope.row.profit >= 0 ? 'profit' : 'loss']">
                  ¥{{ scope.row.profit.toFixed(2) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="profitRate" label="利润率" width="120" sortable align="center">
              <template #default="scope">
                <span :class="scope.row.profitRate >= 0 ? 'positive' : 'negative'">
                  {{ (scope.row.profitRate * 100).toFixed(1) }}%
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 医生统计 -->
      <div v-show="activeTab === 'doctor'" class="tab-content">
        <div class="chart-controls">
          <el-radio-group v-model="doctorChartType" size="small" @change="renderDoctorCharts">
            <el-radio-button label="income">收入分析</el-radio-button>
            <el-radio-button label="patient">门诊人次</el-radio-button>
            <el-radio-button label="prescription">处方分析</el-radio-button>
            <el-radio-button label="ratio">药占比分析</el-radio-button>
          </el-radio-group>
        </div>

        <div class="chart-container">
          <div id="doctorMainChart" class="main-chart" style="height: 500px;"></div>
        </div>

        <el-card class="data-table-card" shadow="never">
          <template #header>
            <div class="table-header">
              <div class="table-title">
                <i class="el-icon-user-solid"></i>
                <span>医生工作统计</span>
              </div>
<!--              <el-button type="primary" size="small" icon="el-icon-download">导出数据</el-button>-->
            </div>
          </template>
          <el-table
              :data="doctorData"
              stripe
              border
              v-loading="doctorLoading"
              style="width: 100%"
              empty-text="暂无医生数据"
          >
            <el-table-column prop="doctorNmae" label="医生姓名" min-width="120" fixed>
              <template #default="scope">
                <div class="doctor-name-cell">
                  <i class="el-icon-user"></i>
                  {{ scope.row.doctorNmae }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="opNum" label="门诊人次" width="120" sortable align="center">
              <template #default="scope">
                <span class="number-cell">{{ scope.row.opNum.toLocaleString() }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="drxNum" label="处方数量" width="120" sortable align="center">
              <template #default="scope">
                <span class="number-cell">{{ scope.row.drxNum.toLocaleString() }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalAmount" label="总金额" width="140" sortable align="right">
              <template #default="scope">
                <span class="money-cell total">¥{{ scope.row.totalAmount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mcAmount" label="药品金额" width="140" sortable align="right">
              <template #default="scope">
                <span class="money-cell drug">¥{{ scope.row.mcAmount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="treatAmount" label="诊疗金额" width="140" sortable align="right">
              <template #default="scope">
                <span class="money-cell treat">¥{{ scope.row.treatAmount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="mcProportion" label="药占比" width="120" sortable align="center">
              <template #default="scope">
                <el-progress
                    :percentage="parseFloat(scope.row.mcProportion)"
                    :show-text="false"
                    :color="getRatioColor(parseFloat(scope.row.mcProportion))"
                />
                <span class="ratio-text">{{ scope.row.mcProportion }}%</span>
              </template>
            </el-table-column>
            <el-table-column prop="avgAmount" label="次均费用" width="140" sortable align="right">
              <template #default="scope">
                <span class="money-cell avg">¥{{ scope.row.avgAmount.toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 财务收入明细 -->
      <div v-show="activeTab === 'finance'" class="tab-content">
        <div class="chart-controls">
          <el-radio-group v-model="financeChartType" size="small" @change="renderFinanceCharts">
            <el-radio-button label="income">收入分析</el-radio-button>
            <el-radio-button label="expense">支出分析</el-radio-button>
            <el-radio-button label="profit">利润分析</el-radio-button>
            <el-radio-button label="ratio">收支比例</el-radio-button>
            <el-radio-button label="detail">明细对比</el-radio-button>
          </el-radio-group>
        </div>

        <div class="chart-container">
          <div id="financeMainChart" class="main-chart" style="height: 500px;"></div>
        </div>

        <!-- 财务汇总卡片 -->
        <div class="finance-summary-cards">
          <el-card class="summary-card income-card" shadow="hover">
            <div class="card-content">
              <div class="card-icon-wrapper" style="background: #f6ffed;">
                <i class="el-icon-wallet" style="color: #52c41a;"></i>
              </div>
              <div class="card-info">
                <div class="card-value">¥{{ totalIncome.toFixed(2) }}</div>
                <div class="card-label">总收入</div>
              </div>
            </div>
          </el-card>

          <el-card class="summary-card expense-card" shadow="hover">
            <div class="card-content">
              <div class="card-icon-wrapper" style="background: #fff2f0;">
                <i class="el-icon-shopping-bag-1" style="color: #ff4d4f;"></i>
              </div>
              <div class="card-info">
                <div class="card-value">¥{{ totalExpense.toFixed(2) }}</div>
                <div class="card-label">总支出</div>
              </div>
            </div>
          </el-card>

          <el-card class="summary-card profit-card" shadow="hover">
            <div class="card-content">
              <div class="card-icon-wrapper" style="background: #e6f7ff;">
                <i class="el-icon-trend-chart" style="color: #1890ff;"></i>
              </div>
              <div class="card-info">
                <div class="card-value" :class="netProfit >= 0 ? 'profit' : 'loss'">
                  {{ netProfit >= 0 ? '+' : '-' }}¥{{ Math.abs(netProfit).toFixed(2) }}
                </div>
                <div class="card-label">净利润</div>
              </div>
            </div>
          </el-card>
        </div>

        <!-- 财务明细表格 -->
        <div class="finance-tables">
          <!-- 收入表格 -->
          <el-card class="data-table-card" shadow="never">
            <template #header>
              <div class="table-header">
                <div class="table-title">
                  <i class="el-icon-money" style="color: #52c41a;"></i>
                  <span>收入明细</span>
                </div>
<!--                <el-button type="success" size="small" icon="el-icon-download" @click="exportIncomeData">导出收入数据</el-button>-->
              </div>
            </template>
            <el-table
                :data="incomeTableData"
                stripe
                border
                v-loading="financeLoading"
                style="width: 100%"
                empty-text="暂无收入数据"
            >
              <el-table-column prop="category" label="收入类别" min-width="180" fixed>
                <template #default="scope">
                  <div class="finance-category-cell">
                    <i class="el-icon-trophy" style="color: #52c41a;"></i>
                    {{ scope.row.category }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="金额" width="140" sortable align="right">
                <template #default="scope">
                  <span class="money-cell income">+¥{{ scope.row.amount.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="percentage" label="占比" width="120" sortable align="center">
                <template #default="scope">
                  <el-progress
                      :percentage="parseFloat(scope.row.percentage)"
                      :show-text="false"
                      :color="getFinanceColor(parseFloat(scope.row.percentage))"
                  />
                  <span class="ratio-text">{{ scope.row.percentage }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="source" label="数据来源" width="120">
                <template #default="scope">
                  <el-tag type="success" size="small">
                    {{ scope.row.source }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <!-- 支出表格 -->
          <el-card class="data-table-card" shadow="never" style="margin-top: 20px;">
            <template #header>
              <div class="table-header">
                <div class="table-title">
                  <i class="el-icon-money" style="color: #ff4d4f;"></i>
                  <span>支出明细</span>
                </div>
<!--                <el-button type="danger" size="small" icon="el-icon-download" @click="exportExpenseData">导出支出数据</el-button>-->
              </div>
            </template>
            <el-table
                :data="expenseTableData"
                stripe
                border
                v-loading="financeLoading"
                style="width: 100%"
                empty-text="暂无支出数据"
            >
              <el-table-column prop="category" label="支出类别" min-width="180" fixed>
                <template #default="scope">
                  <div class="finance-category-cell">
                    <i class="el-icon-shopping-bag-1" style="color: #ff4d4f;"></i>
                    {{ scope.row.category }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="金额" width="140" sortable align="right">
                <template #default="scope">
                  <span class="money-cell expense">-¥{{ scope.row.amount.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="percentage" label="占比" width="120" sortable align="center">
                <template #default="scope">
                  <el-progress
                      :percentage="parseFloat(scope.row.percentage)"
                      :show-text="false"
                      :color="getFinanceColor(parseFloat(scope.row.percentage))"
                  />
                  <span class="ratio-text">{{ scope.row.percentage }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="source" label="数据来源" width="120">
                <template #default="scope">
                  <el-tag type="danger" size="small">
                    {{ scope.row.source }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>

      <!-- 销售分析 -->
      <div v-show="activeTab === 'sales'" class="tab-content">
        <div class="empty-state">
          <i class="el-icon-s-data empty-icon"></i>
          <h3>销售分析模块</h3>
          <p>该模块正在开发中，敬请期待...</p>
          <el-button type="primary">了解更多</el-button>
        </div>
      </div>

      <!-- 患者分析 -->
      <div v-show="activeTab === 'patient'" class="tab-content">
        <div class="empty-state">
          <i class="el-icon-user empty-icon"></i>
          <h3>患者分析模块</h3>
          <p>该模块正在开发中，敬请期待...</p>
          <el-button type="primary">了解更多</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import dayjs from 'dayjs';
import {getDoctorsStatistics, getDrugStatistics, getFinance} from "@/api/statisticalReport/statisticalReport";

export default {
  name: 'MedicalStatisticsTabs',
  data() {
    return {
      activeTab: 'drug',
      dateRange: [],
      drugChartType: 'sale',
      doctorChartType: 'income',
      financeChartType: 'income',
      drugLoading: false,
      doctorLoading: false,
      financeLoading: false,

      // 药品统计数据
      drugData: [],

      // 医生统计数据
      doctorData: [],

      // 财务统计数据
      financeData: {
        otherExpensesRespVO: {},
        otherIncomRespVO: {},
        saleExpensesRespVO: {},
        saleIncomRespVO: {}
      },

      // ECharts实例
      drugMainChart: null,
      doctorMainChart: null,
      financeMainChart: null
    };
  },

  computed: {
    totalDrugs() {
      return this.drugData.length;
    },
    totalDoctors() {
      return this.doctorData.length;
    },
    totalSales() {
      return this.drugData.reduce((sum, item) => sum + item.saleAmt, 0).toFixed(2);
    },
    totalPrescriptions() {
      return this.doctorData.reduce((sum, item) => sum + item.drxNum, 0);
    },

    // 财务相关计算属性
    totalIncome() {
      const saleIncome = Object.values(this.financeData.saleIncomRespVO || {}).reduce((sum, val) => sum + (Number(val) || 0), 0);
      const otherIncome = Object.values(this.financeData.otherIncomRespVO || {}).reduce((sum, val) => sum + (Number(val) || 0), 0);
      return saleIncome + otherIncome;
    },

    totalExpense() {
      const saleExpense = Object.values(this.financeData.saleExpensesRespVO || {}).reduce((sum, val) => sum + (Number(val) || 0), 0);
      const otherExpense = Object.values(this.financeData.otherExpensesRespVO || {}).reduce((sum, val) => sum + (Number(val) || 0), 0);
      return saleExpense + otherExpense;
    },

    netProfit() {
      return this.totalIncome - this.totalExpense;
    },

    // 收入表格数据
    incomeTableData() {
      const data = [];

      // 处理销售收入
      if (this.financeData.saleIncomRespVO) {
        Object.entries(this.financeData.saleIncomRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount !== 0) {
            data.push({
              category: this.getFinanceCategoryName(key, 'income'),
              amount: amount,
              percentage: this.totalIncome > 0 ? ((amount / this.totalIncome) * 100).toFixed(1) : '0.0',
              source: '销售收入'
            });
          }
        });
      }

      // 处理其他收入
      if (this.financeData.otherIncomRespVO) {
        Object.entries(this.financeData.otherIncomRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount !== 0) {
            data.push({
              category: this.getFinanceCategoryName(key, 'otherIncome'),
              amount: amount,
              percentage: this.totalIncome > 0 ? ((amount / this.totalIncome) * 100).toFixed(1) : '0.0',
              source: '其他收入'
            });
          }
        });
      }

      return data.sort((a, b) => b.amount - a.amount);
    },

    // 支出表格数据
    expenseTableData() {
      const data = [];

      // 处理销售支出
      if (this.financeData.saleExpensesRespVO) {
        Object.entries(this.financeData.saleExpensesRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount !== 0) {
            data.push({
              category: this.getFinanceCategoryName(key, 'expense'),
              amount: amount,
              percentage: this.totalExpense > 0 ? ((amount / this.totalExpense) * 100).toFixed(1) : '0.0',
              source: '销售支出'
            });
          }
        });
      }

      // 处理其他支出
      if (this.financeData.otherExpensesRespVO) {
        Object.entries(this.financeData.otherExpensesRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount !== 0) {
            data.push({
              category: this.getFinanceCategoryName(key, 'otherExpense'),
              amount: amount,
              percentage: this.totalExpense > 0 ? ((amount / this.totalExpense) * 100).toFixed(1) : '0.0',
              source: '其他支出'
            });
          }
        });
      }

      return data.sort((a, b) => b.amount - a.amount);
    }
  },

  mounted() {
    this.initDefaultDateRange();
    this.$nextTick(() => {
      this.initCharts();
      this.fetchData();
    });

    // 监听窗口大小变化，重新调整图表大小
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    // 销毁时移除事件监听并销毁图表实例
    window.removeEventListener('resize', this.handleResize);
    if (this.drugMainChart) this.drugMainChart.dispose();
    if (this.doctorMainChart) this.doctorMainChart.dispose();
    if (this.financeMainChart) this.financeMainChart.dispose();
  },

  methods: {
    // 初始化默认时间范围：今年1月1日到当天
    initDefaultDateRange() {
      const startOfYear = dayjs().startOf('year').format('YYYY-MM-DD');
      const today = dayjs().format('YYYY-MM-DD');
      this.dateRange = [startOfYear, today];
    },

    // 获取时间参数
    getTimeParams() {
      if (this.dateRange && this.dateRange.length === 2) {
        return {
          startTime: dayjs(this.dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          endTime: dayjs(this.dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        };
      }
      return {
        startTime: dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      };
    },

    // 获取药品统计数据
    async getDrugStatistics() {
      this.drugLoading = true;
      try {
        const timeParams = this.getTimeParams();
        const res = await getDrugStatistics(timeParams);

        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            // 处理API返回的数据，计算利润和利润率
            this.drugData = res.data.map(item => ({
              ...item,
              profit: item.saleAmt - item.purcAmt,
              profitRate: item.purcAmt > 0 ? (item.saleAmt - item.purcAmt) / item.purcAmt : 0
            }));
            this.$message.success(`获取到 ${this.drugData.length} 条药品数据`);
          } else {
            this.drugData = [];
            this.$message.warning('暂无药品数据');
          }
          // 如果当前在药品标签页，重新渲染图表
          if (this.activeTab === 'drug') {
            this.$nextTick(() => {
              this.renderDrugCharts();
            });
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('获取药品统计数据失败');
        console.error('药品统计接口错误:', error);
      } finally {
        this.drugLoading = false;
      }
    },

    // 获取医生统计数据
    async getDoctorsStatistics() {
      this.doctorLoading = true;
      try {
        const timeParams = this.getTimeParams();
        const res = await getDoctorsStatistics(timeParams);

        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.doctorData = res.data;
            this.$message.success(`获取到 ${this.doctorData.length} 条医生数据`);
          } else {
            this.doctorData = [];
            this.$message.warning('暂无医生数据');
          }
          // 如果当前在医生标签页，重新渲染图表
          if (this.activeTab === 'doctor') {
            this.$nextTick(() => {
              this.renderDoctorCharts();
            });
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('获取医生统计数据失败');
        console.error('医生统计接口错误:', error);
      } finally {
        this.doctorLoading = false;
      }
    },

    // 获取财务统计数据
    async getFinanceStatistics() {
      this.financeLoading = true;
      try {
        const timeParams = this.getTimeParams();
        const res = await getFinance(timeParams);

        if (res.code === 200) {
          if (res.data) {
            this.financeData = res.data;
            this.$message.success('财务数据获取成功');
          } else {
            this.financeData = {
              otherExpensesRespVO: {},
              otherIncomRespVO: {},
              saleExpensesRespVO: {},
              saleIncomRespVO: {}
            };
            this.$message.warning('暂无财务数据');
          }
          // 如果当前在财务标签页，重新渲染图表
          if (this.activeTab === 'finance') {
            this.$nextTick(() => {
              this.renderFinanceCharts();
            });
          }
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error('获取财务统计数据失败');
        console.error('财务统计接口错误:', error);
      } finally {
        this.financeLoading = false;
      }
    },

    // 获取财务类别名称
    getFinanceCategoryName(key, type) {
      const baseNameMap = {
        // 销售收入字段
        chmedAmt: '中草药',
        diagnosAmt: '诊察',
        diagnosMaterialAmt: '诊断材料',
        gtChmedAmt: '中药颗粒',
        medAmt: '西药',
        medMaterialAmt: '医用卫材',
        orthpMaterialAmt: '骨科材料',
        pharmaceAmt: '成药',
        regAmt: '挂号',
        treatAmt: '治疗',

        // 其他收入/支出字段
        drugAdjustmentAmt: '药品调价',
        drugInventoryAmt: '药品盘盈',
        drugReturnAmt: '药品退货',
        drugSterilizaAmt: '药品冲销',
        otherAmt: '其他'
      };

      const baseName = baseNameMap[key] || key;

      // 根据类型添加后缀
      if (type === 'income' || type === 'otherIncome') {
        return baseName + '收入';
      } else if (type === 'expense' || type === 'otherExpense') {
        return baseName + '支出';
      }

      return baseName;
    },

    // 初始化图表
    initCharts() {
      this.drugMainChart = echarts.init(document.getElementById('drugMainChart'));
      this.doctorMainChart = echarts.init(document.getElementById('doctorMainChart'));
      this.financeMainChart = echarts.init(document.getElementById('financeMainChart'));
    },

    // 处理Tab切换
    handleTabClick(tab) {
      this.$nextTick(() => {
        if (tab.name === 'drug') {
          this.renderDrugCharts();
        } else if (tab.name === 'doctor') {
          this.renderDoctorCharts();
        } else if (tab.name === 'finance') {
          this.renderFinanceCharts();
        }
        this.handleResize();
      });
    },

    // 渲染药品相关图表
    renderDrugCharts() {
      // 每次切换前先清空图表
      if (this.drugMainChart) {
        this.drugMainChart.clear();
      }

      // 如果没有数据，显示空状态
      if (!this.drugData || this.drugData.length === 0) {
        this.showEmptyChart('drugMainChart', '暂无药品数据');
        return;
      }

      if (this.drugChartType === 'sale') {
        this.renderDrugSaleChart();
      } else if (this.drugChartType === 'count') {
        this.renderDrugCountChart();
      } else if (this.drugChartType === 'profit') {
        this.renderDrugProfitChart();
      } else if (this.drugChartType === 'type') {
        this.renderDrugTypeChart();
      }
    },

    // 渲染医生相关图表
    renderDoctorCharts() {
      // 每次切换前先清空图表
      if (this.doctorMainChart) {
        this.doctorMainChart.clear();
      }

      // 如果没有数据，显示空状态
      if (!this.doctorData || this.doctorData.length === 0) {
        this.showEmptyChart('doctorMainChart', '暂无医生数据');
        return;
      }

      if (this.doctorChartType === 'income') {
        this.renderDoctorIncomeChart();
      } else if (this.doctorChartType === 'patient') {
        this.renderDoctorPatientChart();
      } else if (this.doctorChartType === 'prescription') {
        this.renderDoctorPrescriptionChart();
      } else if (this.doctorChartType === 'ratio') {
        this.renderDoctorRatioChart();
      }
    },

    // 渲染财务相关图表
    renderFinanceCharts() {
      if (this.financeMainChart) {
        this.financeMainChart.clear();
      }

      if (!this.financeData || Object.keys(this.financeData).length === 0) {
        this.showEmptyChart('financeMainChart', '暂无财务数据');
        return;
      }

      if (this.financeChartType === 'income') {
        this.renderFinanceIncomeChart();
      } else if (this.financeChartType === 'expense') {
        this.renderFinanceExpenseChart();
      } else if (this.financeChartType === 'profit') {
        this.renderFinanceProfitChart();
      } else if (this.financeChartType === 'ratio') {
        this.renderFinanceRatioChart();
      } else if (this.financeChartType === 'detail') {
        this.renderFinanceDetailChart();
      }
    },

    // 显示空状态图表
    showEmptyChart(chartId, text) {
      const option = {
        title: {
          text: text,
          left: 'center',
          top: 'center',
          textStyle: {
            color: '#999',
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        xAxis: {
          show: false
        },
        yAxis: {
          show: false
        },
        series: []
      };

      if (chartId === 'drugMainChart' && this.drugMainChart) {
        this.drugMainChart.setOption(option, true);
      } else if (chartId === 'doctorMainChart' && this.doctorMainChart) {
        this.doctorMainChart.setOption(option, true);
      } else if (chartId === 'financeMainChart' && this.financeMainChart) {
        this.financeMainChart.setOption(option, true);
      }
    },

    // 渲染药品销售图表
    renderDrugSaleChart() {
      const option = {
        title: {
          text: '药品销售额分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            let result = `<div style="font-weight: bold; margin-bottom: 5px;">${params[0].name}</div>`;
            params.forEach(item => {
              const value = item.value.toFixed(2);
              result += `
            <div style="display: flex; align-items: center; margin: 3px 0;">
              <span style="display: inline-block; width: 10px; height: 10px; background: ${item.color}; border-radius: 50%; margin-right: 8px;"></span>
              <span style="flex: 1;">${item.seriesName}:</span>
              <span style="font-weight: bold; color: ${item.color};">¥${value}</span>
            </div>
          `;
            });
            return result;
          }
        },
        legend: {
          data: ['成本金额', '零售金额', '利润'],
          top: 40,
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.drugData.map(item => item.drugName),
          axisLabel: {
            interval: 0,
            rotate: 30,
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
          nameTextStyle: {
            fontSize: 12
          },
          axisLabel: {
            formatter: function(value) {
              return '¥' + value.toFixed(2);  // Y轴标签也显示两位小数
            }
          }
        },
        series: [
          {
            name: '成本金额',
            type: 'bar',
            barWidth: '35%',
            data: this.drugData.map(item => item.purcAmt),
            itemStyle: {
              color: '#ff9c6e'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return '¥' + params.value.toFixed(2);  // 修改这里
              },
              fontSize: 10
            }
          },
          {
            name: '零售金额',
            type: 'bar',
            barWidth: '35%',
            data: this.drugData.map(item => item.saleAmt),
            itemStyle: {
              color: '#597ef7'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return '¥' + params.value.toFixed(2);  // 修改这里
              },
              fontSize: 10
            }
          },
          {
            name: '利润',
            type: 'line',
            data: this.drugData.map(item => item.profit),
            itemStyle: {
              color: '#52c41a'
            },
            symbolSize: 8,
            lineStyle: {
              width: 3
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                const sign = params.value >= 0 ? '+' : '-';  // 利润显示正负号
                return sign + '¥' + Math.abs(params.value).toFixed(2);  // 修改这里
              },
              fontSize: 10,
              fontWeight: 'bold'
            }
          }
        ]
      };

      this.drugMainChart.setOption(option, true);
    },

    // 渲染药品销售数量图表
    renderDrugCountChart() {
      const option = {
        title: {
          text: '药品销售数量统计',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.drugData.map(item => item.drugName),
          axisLabel: {
            interval: 0,
            rotate: 30,
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: '销售数量'
        },
        series: [
          {
            name: '销售数量',
            type: 'bar',
            barWidth: '60%',
            data: this.drugData.map(item => item.cnt),
            itemStyle: {
              color: function(params) {
                const colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452'];
                return colors[params.dataIndex % colors.length];
              }
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 10
            }
          }
        ]
      };

      this.drugMainChart.setOption(option, true);
    },

    // 渲染药品利润图表
    renderDrugProfitChart() {
      const option = {
        title: {
          text: '药品利润率分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.drugData.map(item => item.drugName),
          axisLabel: {
            interval: 0,
            rotate: 30,
            fontSize: 12
          }
        },
        yAxis: {
          type: 'value',
          name: '利润率(%)',
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '利润率',
            type: 'bar',
            barWidth: '60%',
            data: this.drugData.map(item => (item.profitRate * 100).toFixed(1)),
            itemStyle: {
              color: function(params) {
                return params.value >= 30 ? '#52c41a' : params.value >= 20 ? '#faad14' : '#f5222d';
              }
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}%',
              fontSize: 10
            }
          }
        ]
      };

      this.drugMainChart.setOption(option, true);
    },

    // 渲染药品类型图表
    renderDrugTypeChart() {
      const westernDrugs = this.drugData.filter(item => item.type === 1);
      const chineseDrugs = this.drugData.filter(item => item.type === 2);

      const westernSales = westernDrugs.reduce((sum, item) => sum + item.saleAmt, 0);
      const chineseSales = chineseDrugs.reduce((sum, item) => sum + item.saleAmt, 0);

      const option = {
        title: {
          text: '药品类型分布',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: ¥{c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle',
          data: ['西药', '中药']
        },
        series: [
          {
            name: '销售额',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: westernSales,
                name: '西药',
                itemStyle: { color: '#1890ff' }
              },
              {
                value: chineseSales,
                name: '中药',
                itemStyle: { color: '#52c41a' }
              }
            ]
          }
        ]
      };

      this.drugMainChart.setOption(option, true);
    },

    // 渲染医生收入图表
    renderDoctorIncomeChart() {
      const option = {
        title: {
          text: '医生收入分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['总金额', '药品金额', '诊疗金额'],
          top: 40,
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.doctorData.map(item => item.doctorNmae)
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [
          {
            name: '总金额',
            type: 'bar',
            barWidth: '25%',
            data: this.doctorData.map(item => item.totalAmount),
            itemStyle: {
              color: '#1890ff'
            },
            label: {
              show: true,
              position: 'top',
              formatter: '¥{c}',
              fontSize: 10
            }
          },
          {
            name: '药品金额',
            type: 'bar',
            barWidth: '25%',
            data: this.doctorData.map(item => item.mcAmount),
            itemStyle: {
              color: '#52c41a'
            },
            label: {
              show: true,
              position: 'top',
              formatter: '¥{c}',
              fontSize: 10
            }
          },
          {
            name: '诊疗金额',
            type: 'bar',
            barWidth: '25%',
            data: this.doctorData.map(item => item.treatAmount),
            itemStyle: {
              color: '#fa8c16'
            },
            label: {
              show: true,
              position: 'top',
              formatter: '¥{c}',
              fontSize: 10
            }
          }
        ]
      };

      this.doctorMainChart.setOption(option, true);
    },

    // 渲染医生门诊人次图表
    renderDoctorPatientChart() {
      const option = {
        title: {
          text: '医生门诊人次统计',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.doctorData.map(item => item.doctorNmae)
        },
        yAxis: {
          type: 'value',
          name: '门诊人次'
        },
        series: [
          {
            name: '门诊人次',
            type: 'bar',
            barWidth: '60%',
            data: this.doctorData.map(item => item.opNum),
            itemStyle: {
              color: '#722ed1'
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 10
            }
          }
        ]
      };

      this.doctorMainChart.setOption(option, true);
    },

    // 渲染医生处方图表
    renderDoctorPrescriptionChart() {
      const option = {
        title: {
          text: '医生处方数量统计',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.doctorData.map(item => item.doctorNmae)
        },
        yAxis: {
          type: 'value',
          name: '处方数量'
        },
        series: [
          {
            name: '处方数量',
            type: 'bar',
            barWidth: '60%',
            data: this.doctorData.map(item => item.drxNum),
            itemStyle: {
              color: '#eb2f96'
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 10
            }
          }
        ]
      };

      this.doctorMainChart.setOption(option, true);
    },

    // 渲染医生药占比图表
    renderDoctorRatioChart() {
      const option = {
        title: {
          text: '医生药占比分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            return `${params[0].name}<br/>药占比: ${params[0].value}%`;
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: this.doctorData.map(item => item.doctorNmae)
        },
        yAxis: {
          type: 'value',
          name: '药占比(%)',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '药占比',
            type: 'bar',
            barWidth: '60%',
            data: this.doctorData.map(item => parseFloat(item.mcProportion)),
            itemStyle: {
              color: function(params) {
                const value = params.value;
                if (value > 60) {
                  return '#f5222d';
                } else if (value > 50) {
                  return '#faad14';
                } else {
                  return '#52c41a';
                }
              }
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}%',
              fontSize: 10
            }
          }
        ]
      };

      this.doctorMainChart.setOption(option, true);
    },

    // 渲染财务收入图表
    renderFinanceIncomeChart() {
      const incomeData = [];

      // 合并所有收入数据
      if (this.financeData.saleIncomRespVO) {
        Object.entries(this.financeData.saleIncomRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount > 0) {
            incomeData.push({
              name: this.getFinanceCategoryName(key, 'income'),
              value: amount
            });
          }
        });
      }

      if (this.financeData.otherIncomRespVO) {
        Object.entries(this.financeData.otherIncomRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount > 0) {
            incomeData.push({
              name: this.getFinanceCategoryName(key, 'otherIncome'),
              value: amount
            });
          }
        });
      }

      // 按金额排序，取前15个
      const sortedData = incomeData.sort((a, b) => b.value - a.value).slice(0, 15);

      const option = {
        title: {
          text: '收入构成分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: ¥{c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          data: sortedData.map(item => item.name)
        },
        series: [
          {
            name: '收入',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: sortedData,
            itemStyle: {
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: {d}%'
            }
          }
        ]
      };

      this.financeMainChart.setOption(option, true);
    },

    // 渲染财务支出图表
    renderFinanceExpenseChart() {
      const expenseData = [];

      // 合并所有支出数据
      if (this.financeData.saleExpensesRespVO) {
        Object.entries(this.financeData.saleExpensesRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount > 0) {
            expenseData.push({
              name: this.getFinanceCategoryName(key, 'expense'),
              value: amount
            });
          }
        });
      }

      if (this.financeData.otherExpensesRespVO) {
        Object.entries(this.financeData.otherExpensesRespVO).forEach(([key, value]) => {
          const amount = Number(value) || 0;
          if (amount > 0) {
            expenseData.push({
              name: this.getFinanceCategoryName(key, 'otherExpense'),
              value: amount
            });
          }
        });
      }

      // 按金额排序，取前15个
      const sortedData = expenseData.sort((a, b) => b.value - a.value).slice(0, 15);

      const option = {
        title: {
          text: '支出构成分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: ¥{c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
          data: sortedData.map(item => item.name)
        },
        series: [
          {
            name: '支出',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: sortedData,
            itemStyle: {
              color: function(params) {
                // 使用红色系颜色表示支出
                const colors = ['#ff4d4f', '#ff7875', '#ff9c6e', '#ffbb96', '#ffd8bf', '#ffccc7', '#ffa39e', '#ff7a45', '#fa541c', '#d4380d'];
                return colors[params.dataIndex % colors.length];
              },
              borderRadius: 8,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: {d}%'
            }
          }
        ]
      };

      this.financeMainChart.setOption(option, true);
    },

    // 渲染财务利润图表
    renderFinanceProfitChart() {
      const option = {
        title: {
          text: '财务利润分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            let result = `<div style="font-weight: bold; margin-bottom: 5px;">${params[0].name}</div>`;
            params.forEach(item => {
              const value = Math.abs(item.value).toFixed(2);
              const sign = item.value >= 0 ? '+' : '-';
              result += `
                <div style="display: flex; align-items: center; margin: 3px 0;">
                  <span style="display: inline-block; width: 10px; height: 10px; background: ${item.color}; border-radius: 50%; margin-right: 8px;"></span>
                  <span style="flex: 1;">${item.seriesName}:</span>
                  <span style="font-weight: bold; color: ${item.color};">${sign}¥${value}</span>
                </div>
              `;
            });
            return result;
          }
        },
        legend: {
          data: ['总收入', '总支出', '净利润'],
          top: 40
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['财务汇总']
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [
          {
            name: '总收入',
            type: 'bar',
            data: [this.totalIncome],
            itemStyle: {
              color: '#52c41a'
            },
            label: {
              show: true,
              position: 'top',
              formatter: '¥{c}'
            }
          },
          {
            name: '总支出',
            type: 'bar',
            data: [this.totalExpense],
            itemStyle: {
              color: '#ff4d4f'
            },
            label: {
              show: true,
              position: 'top',
              formatter: '¥{c}'
            }
          },
          {
            name: '净利润',
            type: 'bar',
            data: [this.netProfit],
            itemStyle: {
              color: this.netProfit >= 0 ? '#1890ff' : '#faad14'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                const sign = params.value >= 0 ? '+' : '-';
                return `${sign}¥${Math.abs(params.value).toFixed(2)}`;
              }
            }
          }
        ]
      };

      this.financeMainChart.setOption(option, true);
    },

    // 渲染财务收支比例图表
    renderFinanceRatioChart() {
      const option = {
        title: {
          text: '总体收支分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: ¥{c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center'
        },
        series: [
          {
            name: '财务分布',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            data: [
              {
                value: this.totalIncome,
                name: '总收入',
                itemStyle: { color: '#52c41a' }
              },
              {
                value: this.totalExpense,
                name: '总支出',
                itemStyle: { color: '#ff4d4f' }
              }
            ],
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            label: {
              formatter: '{b}: {d}%'
            }
          }
        ]
      };

      this.financeMainChart.setOption(option, true);
    },

    // 渲染财务明细对比图表
    renderFinanceDetailChart() {
      const categories = [];
      const incomeData = [];
      const expenseData = [];

      // 收集所有类别
      const allCategories = new Set();

      // 收入类别
      if (this.financeData.saleIncomRespVO) {
        Object.keys(this.financeData.saleIncomRespVO).forEach(key => {
          allCategories.add(this.getFinanceCategoryName(key, 'income'));
        });
      }
      if (this.financeData.otherIncomRespVO) {
        Object.keys(this.financeData.otherIncomRespVO).forEach(key => {
          allCategories.add(this.getFinanceCategoryName(key, 'otherIncome'));
        });
      }

      // 支出类别
      if (this.financeData.saleExpensesRespVO) {
        Object.keys(this.financeData.saleExpensesRespVO).forEach(key => {
          allCategories.add(this.getFinanceCategoryName(key, 'expense'));
        });
      }
      if (this.financeData.otherExpensesRespVO) {
        Object.keys(this.financeData.otherExpensesRespVO).forEach(key => {
          allCategories.add(this.getFinanceCategoryName(key, 'otherExpense'));
        });
      }

      // 转换为数组并排序
      categories.push(...Array.from(allCategories).sort());

      // 填充数据
      categories.forEach(category => {
        let income = 0;
        let expense = 0;

        // 查找收入
        if (this.financeData.saleIncomRespVO) {
          Object.entries(this.financeData.saleIncomRespVO).forEach(([key, value]) => {
            if (this.getFinanceCategoryName(key, 'income') === category) {
              income += Number(value) || 0;
            }
          });
        }
        if (this.financeData.otherIncomRespVO) {
          Object.entries(this.financeData.otherIncomRespVO).forEach(([key, value]) => {
            if (this.getFinanceCategoryName(key, 'otherIncome') === category) {
              income += Number(value) || 0;
            }
          });
        }

        // 查找支出
        if (this.financeData.saleExpensesRespVO) {
          Object.entries(this.financeData.saleExpensesRespVO).forEach(([key, value]) => {
            if (this.getFinanceCategoryName(key, 'expense') === category) {
              expense += Number(value) || 0;
            }
          });
        }
        if (this.financeData.otherExpensesRespVO) {
          Object.entries(this.financeData.otherExpensesRespVO).forEach(([key, value]) => {
            if (this.getFinanceCategoryName(key, 'otherExpense') === category) {
              expense += Number(value) || 0;
            }
          });
        }

        incomeData.push(income);
        expenseData.push(expense);
      });

      const option = {
        title: {
          text: '财务明细对比分析',
          left: 'center',
          textStyle: {
            color: '#1a73e8',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['收入', '支出'],
          top: 40
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            interval: 0,
            rotate: 45,
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          name: '金额(元)',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [
          {
            name: '收入',
            type: 'bar',
            data: incomeData,
            itemStyle: {
              color: '#52c41a'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return params.value > 0 ? '¥' + params.value.toFixed(0) : '';
              },
              fontSize: 8
            }
          },
          {
            name: '支出',
            type: 'bar',
            data: expenseData,
            itemStyle: {
              color: '#ff4d4f'
            },
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                return params.value > 0 ? '¥' + params.value.toFixed(0) : '';
              },
              fontSize: 8
            }
          }
        ]
      };

      this.financeMainChart.setOption(option, true);
    },

    // 获取药占比颜色
    getRatioColor(ratio) {
      if (ratio > 60) {
        return '#f5222d';
      } else if (ratio > 50) {
        return '#faad14';
      } else {
        return '#52c41a';
      }
    },

    // 获取财务颜色
    getFinanceColor(percentage) {
      if (percentage > 30) {
        return '#52c41a';
      } else if (percentage > 15) {
        return '#1890ff';
      } else {
        return '#faad14';
      }
    },

    // 导出收入数据
    exportIncomeData() {
      this.$message.success('收入数据导出功能开发中');
    },

    // 导出支出数据
    exportExpenseData() {
      this.$message.success('支出数据导出功能开发中');
    },

    // 处理日期变化
    handleDateChange() {
      this.fetchData();
    },

    // 获取数据
    fetchData() {
      this.getDrugStatistics();
      this.getDoctorsStatistics();
      this.getFinanceStatistics();
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.drugMainChart) this.drugMainChart.resize();
      if (this.doctorMainChart) this.doctorMainChart.resize();
      if (this.financeMainChart) this.financeMainChart.resize();
    }
  }
};
</script>

<style scoped>
.medical-stats-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.header-left {
  flex: 1;
}

.page-title {
  font-size: 24px;
  color: #1a73e8;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.page-title i {
  margin-right: 10px;
  font-size: 28px;
}

.page-subtitle {
  color: #606266;
  font-size: 14px;
  margin: 0;
}

.date-filter {
  display: flex;
  gap: 10px;
  align-items: center;
}

.overview-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.overview-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  border: none;
  border-left: 4px solid #1a73e8;
}

.overview-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.card-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.card-icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.card-icon {
  font-size: 28px;
}

.card-info {
  flex: 1;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #1a73e8;
  margin-bottom: 4px;
}

.card-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.main-content-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

::v-deep .el-card__header {
  padding: 0;
  border-bottom: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.tab-header {
  padding: 0 20px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #e8e8e8;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
  border-radius: 8px 8px 0 0;
  border: 1px solid #e8e8e8;
  margin-right: 8px;
  padding: 0 24px;
  height: 44px;
  line-height: 44px;
  font-weight: 500;
  transition: all 0.3s ease;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
  background: linear-gradient(135deg, #1a73e8 0%, #1565c0 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
}

.tab-label {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.tab-label i {
  margin-right: 6px;
  font-size: 16px;
}

.tab-content {
  padding: 24px;
}

.chart-controls {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

::v-deep .el-radio-group {
  background: #f8f9fa;
  padding: 4px;
  border-radius: 8px;
}

::v-deep .el-radio-button__inner {
  border: none !important;
  border-radius: 6px !important;
  margin: 0 2px;
}

::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: linear-gradient(135deg, #1a73e8 0%, #1565c0 100%);
  box-shadow: 0 2px 6px rgba(26, 115, 232, 0.3);
}

.chart-container {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
}

.main-chart {
  width: 100%;
}

.data-table-card {
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
}

.table-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1a73e8;
}

.table-title i {
  margin-right: 8px;
  font-size: 18px;
}

.drug-name-cell, .doctor-name-cell {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.drug-name-cell i, .doctor-name-cell i {
  margin-right: 8px;
  font-size: 16px;
}

.number-cell {
  font-weight: 600;
  color: #333;
}

.money-cell {
  font-weight: 600;
}

.money-cell.cost {
  color: #ff4d4f;
}

.money-cell.sale {
  color: #1890ff;
}

.money-cell.profit {
  color: #52c41a;
}

.money-cell.loss {
  color: #ff4d4f;
}

.money-cell.total {
  color: #1890ff;
}

.money-cell.drug {
  color: #52c41a;
}

.money-cell.treat {
  color: #fa8c16;
}

.money-cell.avg {
  color: #722ed1;
}

.money-cell.income {
  color: #52c41a;
}

.money-cell.expense {
  color: #ff4d4f;
}

.positive {
  color: #52c41a;
  font-weight: 600;
}

.negative {
  color: #ff4d4f;
  font-weight: 600;
}

.ratio-text {
  display: block;
  text-align: center;
  margin-top: 4px;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

/* 财务相关样式 */
.finance-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.summary-card {
  border-radius: 12px;
  transition: all 0.3s ease;
  border: none;
}

.income-card {
  border-left: 4px solid #52c41a;
}

.expense-card {
  border-left: 4px solid #ff4d4f;
}

.profit-card {
  border-left: 4px solid #1890ff;
}

.finance-category-cell {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.finance-category-cell i {
  margin-right: 8px;
  font-size: 16px;
}

.profit {
  color: #52c41a;
}

.loss {
  color: #ff4d4f;
}

.finance-tables {
  margin-top: 20px;
}

.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #666;
}

.empty-icon {
  font-size: 72px;
  color: #d9d9d9;
  margin-bottom: 20px;
}

.empty-state h3 {
  font-size: 20px;
  margin-bottom: 12px;
  color: #333;
  font-weight: 600;
}

.empty-state p {
  margin-bottom: 24px;
  font-size: 14px;
  color: #909399;
}

/* 表格空状态样式 */
::v-deep .el-table__empty-block {
  padding: 60px 0;
}

::v-deep .el-table__empty-text {
  color: #909399;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
  }

  .date-filter {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .medical-stats-container {
    padding: 12px;
  }

  .overview-cards {
    grid-template-columns: 1fr;
  }

  .chart-controls {
    overflow-x: auto;
    justify-content: flex-start;
  }

  .tab-content {
    padding: 16px;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .finance-summary-cards {
    grid-template-columns: 1fr;
  }

  ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
    padding: 0 16px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .card-content {
    flex-direction: column;
    text-align: center;
  }

  .card-icon-wrapper {
    margin-right: 0;
    margin-bottom: 12px;
  }

  .date-filter {
    flex-direction: column;
    width: 100%;
  }

  .date-filter .el-date-editor {
    width: 100%;
    margin-bottom: 8px;
  }

  .date-filter .el-button {
    width: 100%;
  }
}
</style>